import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
Vue.use(Router);
export default new Router({
    mode: "history",
    base: "/",
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
            alias: "/home",
            meta: {
                title: "首页",
                keepAlive: true,
                indexAlive: true,
            },
        },
        {
            path: "/register",
            name: "register",
            component: () =>
                import(/* webpackChunkName: "login" */ "./views/Register.vue"),
            meta: {
                headHide: true,
                footHide: true,
                title: "注册",
            },
        },
        {
            path: "/login",
            name: "login",
            component: () =>
                import(/* webpackChunkName: "login" */ "./views/Login.vue"),
            meta: {
                headHide: true,
                footHide: true,
                title: "登录",
            },
        },
        {
            path: "/search",
            name: "search",
            component: () =>
                import(/* webpackChunkName: "product" */ "./views/SearchResult.vue"),
            meta: {
                title: "展台方案",
                keepAlive: true,
            },
        },
        {
            path: "/search2",
            name: "search2",
            component: () =>
                import(/* webpackChunkName: "product" */ "./views/SearchResult2.vue"),
            meta: {
                title: "展台方案",
                keepAlive: true,
            },
        },
        {
            path: "/detail/:goodsId",
            name: "detail",
            component: () =>
                import(/* webpackChunkName: "product" */ "./views/ProductDetail.vue"),
            meta: {
                title: "商品详情",
                keepAlive: true,
            },
        },
        {
            path: "/casedetail/:goodsId",
            name: "casedetail",
            component: () =>
                import(/* webpackChunkName: "product" */ "./views/CaseDetail.vue"),
            meta: {
                title: "案例详情",
                keepAlive: true,
            },
        },
        {
            path: "/aboutdetail/:goodsId",
            name: "aboutdetail",
            component: () =>
                import(/* webpackChunkName: "product" */ "./views/AboutDetail.vue"),
            meta: {
                title: "关于我们",
                keepAlive: true,
            },
        },
        {
            path: "/buySuccess",
            name: "buySuccess",
            component: () =>
                import(/* webpackChunkName: "product" */ "./views/BuySuccess.vue"),
            meta: {
                title: "成功加入购物车",
                keepAlive: true,
            },
        },
        {
            path: "/paySuccess",
            name: "paySuccess",
            component: () =>
                import(/* webpackChunkName: "product" */ "./views/PaySuccess.vue"),
            meta: {
                title: "支付成功",
                keepAlive: true,
            },
        },
        {
            path: "/cart",
            name: "cart",
            component: () =>
                import(/* webpackChunkName: "cart" */ "./views/MyCart.vue"),
            meta: {
                title: "我的购物车",
                keepAlive: true,
            },
        },
        {
            path: "/order",
            name: "order",
            component: () =>
                import(/* webpackChunkName: "cart" */ "./views/Order.vue"),
            meta: {
                keepAlive: true,
                title: "填写订单信息",
            },
        },
        {
            path: "/center",
            name: "center",
            component: () =>
                import(/* webpackChunkName: "center" */ "./views/Center/Index.vue"),
            // redirect: '/center/user',
            redirect: { name: "User" },
            meta: {
                footShow: true,
                keepAlive: true,
            },
            children: [
                {
                    path: "user",
                    name: "User",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/User.vue"),
                    meta: {
                        title: "我的个人中心",
                        keepAlive: true,
                    },
                },
                {
                    path: "favourite",
                    name: "favourite",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/Favourite.vue"),
                    meta: {
                        title: "我的收藏",
                        keepAlive: true,
                    },
                },
                {
                    path: "myquiteorder",
                    name: "myquiteorder",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/MyQuiteOrder.vue"),
                    meta: {
                        title: "租赁订单",
                        keepAlive: true,
                    },
                },
                {
                    path: "footmark",
                    name: "footmark",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/FootMark.vue"),
                    meta: {
                        title: "我的足迹",
                        keepAlive: true,
                    },
                },
                {
                    path: "balance",
                    name: "balance",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/Balance.vue"),
                    meta: {
                        title: "我的余额",
                        keepAlive: true,
                    },
                },
                {
                    path: "recharge",
                    name: "recharge",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/Recharge.vue"),
                    meta: {
                        title: "余额充值",
                        keepAlive: true,
                    },
                },
                {
                    path: "myOrder",
                    name: "myOrder",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/MyOrder.vue"),
                    meta: {
                        title: "我的订单",
                        keepAlive: true,
                    },
                },
                {
                    path: "myCurOrder",
                    name: "myCurOrder",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/MyCurOrder.vue"),
                    meta: {
                        title: "我的定制订单",
                        keepAlive: true,
                    },
                },
                {
                    path: "orderDetail/:order_id",
                    name: "orderDetail",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/OrderDetail.vue"),
                    meta: {
                        title: "订单详情",
                        keepAlive: true,
                    },
                },
                {
                    path: "cusOrderDetail/:order_id",
                    name: "cusOrderDetail",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/CusOrderDetail.vue"),
                    meta: {
                        title: "定制订单详情",
                        keepAlive: true,
                    },
                },
                {
                    path: "userInfo",
                    name: "userInfo",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/UserInfo.vue"),
                    meta: {
                        title: "资料设置",
                        keepAlive: true,
                    },
                },
                {
                    path: "safeCenter",
                    name: "safeCenter",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/SafeCenter.vue"),
                    meta: {
                        title: "安全中心",
                        keepAlive: true,
                    },
                },
                {
                    path: "address",
                    name: "address",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/Address.vue"),
                    meta: {
                        title: "收货地址",
                        keepAlive: true,
                    },
                },
                {
                    path: "point",
                    name: "point",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/Point.vue"),
                    meta: {
                        title: "我的积分",
                        keepAlive: true,
                    },
                },
                {
                    path: "coupon",
                    name: "coupon",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/Coupon.vue"),
                    meta: {
                        title: "我的优惠券",
                        keepAlive: true,
                    },
                },
                {
                    path: "receipt",
                    name: "receipt",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/Receipt.vue"),
                    meta: {
                        title: "我的发票",
                        keepAlive: true,
                    },
                },
                {
                    path: "refund",
                    name: "refund",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/Refund/Index.vue"),
                    meta: {
                        title: "申请退换货",
                        keepAlive: true,
                    },
                },
                {
                    path: "refundDetail/:aftersales_id",
                    name: "refundDetail",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/Refund/RefundDetail.vue"),
                    meta: {
                        title: "退换货详情",
                        keepAlive: true,
                    },
                },
                {
                    path: "uploadDesign/:order_id",
                    name: "uploadDesign",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/Refund/UploadDesign.vue"),
                    meta: {
                        title: "上传设计",
                        keepAlive: true,
                    },
                },
                {
                    path: "refundApply/:order_id",
                    name: "refundApply",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/Refund/RefundApply.vue"),
                    meta: {
                        title: "退换货申请",
                        keepAlive: true,
                    },
                },
                {
                    path: "currefundApply/:order_id",
                    name: "currefundApply",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/Refund/CurRefundApply.vue"),
                    meta: {
                        title: "申请回收",
                        keepAlive: true,
                    },
                },
                {
                    path: "currefundApply2/:order_id",
                    name: "currefundApply2",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/Refund/CurRefundApply2.vue"),
                    meta: {
                        title: "确认回收",
                        keepAlive: true,
                    },
                },
                {
                    path: "evaluate",
                    name: "evaluate",
                    component: () =>
                        import(/* webpackChunkName: "center" */ "./views/Center/Evaluate.vue"),
                    meta: {
                        title: "评价订单",
                        keepAlive: true,
                    },
                },
            ],
        },
        {
            path: "/help",
            name: "help",
            component: () =>
                import(/* webpackChunkName: "center" */ "./views/Help/Index.vue"),
            meta: {
                footShow: true,
            },
        },
        {
            path: "/about",
            name: "about",
            component: () =>
                import(/* webpackChunkName: "center" */ "./views/About.vue"),
            meta: {
                title: "关于我们",
                keepAlive: true,
            },
        },
        {
            path: "/customizedservice",
            name: "customizedservice",
            component: () =>
                import(/* webpackChunkName: "center" */ "./views/CustomizedService.vue"),
            meta: {
                title: "在线下单",
                keepAlive: true,
            },
        },
        {
            path: "/rentalservice",
            name: "rentalservice",
            component: () =>
                import(/* webpackChunkName: "center" */ "./views/RentalService.vue"),
            meta: {
                title: "租赁服务",
                keepAlive: true,
            },
        },

        {
            path: "/case/:selectedCatId?",
            name: "case",
            component: () =>
                import(/* webpackChunkName: "center" */ "./views/Case.vue"),
            meta: {
                title: "套装案例",
                keepAlive: true,
            },
        },
        {
            path: "/cashier/:order_id",
            name: "cashier",
            component: () =>
                import(/* webpackChunkName: "center" */ "./views/Cashier.vue"),
            meta: {
                title: "收银台",
                headHide: true,
            },
        },
        {
            path: "*",
            redirect: "/",
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});
